import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';
import api from '../../api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      await axios.post(api.recoverPassword, { email });
      setSuccessMessage('');
      setStep(2);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error sending OTP:', error);
      if (error.response) {
        setError(
          error.response.data.message || 'Error sending OTP. Please try again.',
        );
      } else {
        setError('Server is unreachable. Please try again later.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    try {
      await axios
        .post(api.resetPassword, {
          email,
          otp,
          newPassword,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        });

      setSuccessMessage('Password reset successful!');
      navigate('/login');
    } catch (error) {
      setError('Invalid OTP or expired.');
    }
  };

  return (
    <div className="auth-container">
      {/* Background with GIF */}
      <div className="bg">
        <img src="/front-end-images/fps.gif" className="im" alt="Background Animation" />

      </div>

      {/* Form Container */}
      {error && <div className="error">{error}</div>}
      {successMessage && <div className="success">{successMessage}</div>}

      {step === 1 ? (
        <form onSubmit={handleEmailSubmit}>
          <h2 className="forgot-h2">Forgot Password</h2>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Sending OTP...
              </>
            ) : (
              'Send OTP'
            )}
          </button>
        </form>
      ) : (
        <form onSubmit={handlePasswordReset}>
          <h2 className="forgot-h2">Reset Password</h2>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <button type="submit">Reset Password</button>
        </form>
      )}
    </div>
  );
};

export default ForgotPassword;
